import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";

import { Spinner } from "@/components/ui/spinner";
import { useAuth } from "@/contexts/AuthContext";
import { resolveLandingRoute } from "@/lib/resolve-landing-route";

export const Route = createFileRoute("/")({
  component: IndexPage,
});

function IndexPage() {
  const { isLoading, isAuthenticated, userRoleType } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoading) {
      if (isAuthenticated) {
        navigate({ to: resolveLandingRoute(userRoleType), replace: true });
      } else {
        navigate({ to: "/login", replace: true });
      }
    }
  }, [isLoading, isAuthenticated, userRoleType, navigate]);

  // Show loading while determining auth state
  return (
    <div className="flex h-screen items-center justify-center">
      <Spinner className="h-8 w-8 text-primary" />
    </div>
  );
}
